<div class="time-picker flex" (wfmOutsideMousedown)="open = false">
  <div class="time-picker__time-select-container">
    <div
      role="listbox"
      class="select time-picker__time-select select__single select--pristine select--bottom select--touched select__demo-spacing"
      [class.select--disabled]="disabled"
      [class.select--error]="error"
      [class.select--open]="open && !disabled"
    >
      <div class="select__container" (click)="open = !open && !disabled">
        <div class="select__value-container">
          <div class="select__placeholder" *ngIf="!input">{{ placeholder }}</div>
          <div class="select__value" *ngIf="input">
            <span class="select__value-label">{{ input }}</span>
          </div>
          <div class="select__input">
            <input
              role="combobox"
              type="text"
              readonly=""
              [attr.autocomplete]="'panel-' + id"
              aria-expanded="true"
              [attr.aria-owns]="'panel-' + id"
              aria-activedescendant="c"
            />
          </div>
        </div>
        <span class="select__arrow-wrapper"> <span class="select__arrow"></span> </span>
      </div>

      <div [id]="'panel-' + id" class="select__dropdown-panel select--bottom select__dropdown-panel--open" *ngIf="open">
        <div class="select__dropdown-panel-items scroll-host">
          <div>
            <div role="option" class="select__option" *ngIf="!required" (click)="select()">
              <span class="select__option-label--placeholder"> --- </span>
            </div>
            <div
              role="option"
              class="select__option"
              *ngFor="let option of options; index as i"
              [id]="'pane-' + id + '-option-' + i"
              [class.select__option--selected]="input === option"
              (click)="select(option)"
            >
              <span class="select__option-label"> {{ option }} </span>
            </div>
          </div>
        </div>
      </div>

      <div class="select__icon" (click)="open = !open && !disabled">
        <svg-icon
          name="ico-clock-16"
          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
          [ngStyle]="{ height: '16px' }"
        >
        </svg-icon>
      </div>
    </div>
  </div>
</div>
